
import { useContext, useState, useRef } from 'react';

import Modal from 'react-bootstrap/Modal';
import DataContext from '../context';
import Skeleton from 'react-loading-skeleton';

function ChangeStoreModal() {
    const didMountRef = useRef(true);
    const [isLoader, setisLoader] = useState(false);
    const contextValues = useContext(DataContext)
    const changeStoreModal = () => {
        contextValues.setToggleChangeStoreModal(!contextValues.togglechangeStoreModal)
    }
    const onChangeStore = (store) => {
        deleteCoupon()
        localStorage.setItem('selectedStore', JSON.stringify(store))
        contextValues.setselectedStore(store)
        changeStoreModal()
    }
    const deleteCoupon = () => {
        localStorage.removeItem("COUPON_SESSION");
        const couponSession = localStorage.getItem("COUPON_SESSION");
        const parsedCouponSession = couponSession ? JSON.parse(couponSession) : {
            discount_amount: 0.0,
            promo_id: 0,
            promo_code: "",
            free_item: 0,
        };
        contextValues.setSelectedCoupon(parsedCouponSession);
    }
    return (
        <>
            <Modal className='changeModal bottom' show={contextValues.togglechangeStoreModal} onHide={(e) => changeStoreModal()} backdrop="static">
                <div className='changeModalContent'>
                    <button type='button' className='modal-close' onClick={() => { changeStoreModal() }}><i className="ri-close-line"></i></button>
                    {contextValues.storesData && contextValues.storesData.length > 0 ?
                        <div className='changeModalContent-inner'>
                            <h5>Pickup location</h5>
                            <p>Choose your pickup location</p>
                            {contextValues.storesData?.map((item, index) => (
                                <div className={`picku_address_box ${contextValues.selectedStore.store_id == item?.store_id ? 'active' : ''}`} key={index} onClick={() => { onChangeStore(item) }}>
                                    <div className="picku_addre">
                                        <div className="picku_addre_icon"><i className="ri-store-2-line"></i></div>
                                        <div className="picku_addre_cont">
                                            <h5 className="mb-0 tx-16">{item?.store_name}</h5>
                                            <p className="mb-0 tx-14">{item?.store_address}</p>
                                        </div>
                                    </div>
                                    <div className='pickupselect'><span></span></div>
                                </div>
                            ))}
                        </div> :
                        <div className='changeModalContent-inner'>
                            <h5>Store Closed</h5>
                            <p>All Stores are closed</p>
                            <div className='noimg text-center'>
                                <img src='/img/storeclosed.png' className='wd-200' alt='cart'></img>
                                <h5>Sorry we're closed </h5>
                                <p>Sorry, we're currently closed. Please visit us again soon!</p>
                            </div>
                        </div>
                    }
                </div>
            </Modal>
        </>
    );
}

export default ChangeStoreModal